import styled from "styled-components";
import { theme } from "../../styles/theme";

export const Title = styled.div`
  color: ${theme.colors.lightBlue};
  font-family: "Poppins";
  margin-bottom: 15px;
`;

export const LabelStyled = styled.div`
  color: ${theme.colors.white};
  font-size: 12px;
  margin-right: 15px;
`;

export const RowStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 9px;
  width: 100%;

  color: ${theme.colors.white};
  font-family: ${theme.font.poppins};

  @media screen and (max-width: 479px) {
    flex-wrap: wrap;
    .w-25 {
      width: 100% !important;
    }
  }
`;

export const Flex = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  &>div {
    margin: 0;
  }
  margin-bottom: 1rem;
`;

export const ValueStyled = styled.div`
  border-radius: 20px;
  border: 1px solid ${theme.colors.white};
  padding: 3px 10px;
  min-width: 70%;

  color: ${theme.colors.white};
  font-size: 14px;

  @media screen and (max-width: 479px) {
    min-width: 100%;
    flex-wrap: wrap;
    .w-25 {
      width: 100% !important;
    }
  }
`;

export const SectionStyled = styled.div``;

export const Wrapper = styled.div`
  padding: 15px;
  background-color: ${theme.colors.darkBlue};

  @media screen and (max-width: 479px) {
    .mobile-style {
      flex-wrap: wrap;
      gap: 1rem;
    }
  }
`;
